import { Injectable } from '@angular/core';
import { AbstractSecurityStorage } from 'angular-auth-oidc-client';

@Injectable({
  providedIn: 'root',
})
export class StorageService implements AbstractSecurityStorage {
  read = (key: string) => localStorage.getItem(key);

  write = (key: string, value: string): void => {
    localStorage.setItem(key, value);
  };

  remove = (key: string): void => {
    localStorage.removeItem(key);
  };

  clear = (): void => {
    localStorage.clear();
  };
}
